import React, { ElementType } from 'react';

import { Collapse, Grid, TableCell, TableCellBaseProps, TableRow, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ColumnDefinition } from 'components/DataTable/DataTableTypes';

export const tableStyles = makeStyles(() => ({
  emptyTable: {
    borderBottom: 'none',
  },
  cell: {
    padding: 0,
  },
}));

type Props<T> = {
  rowIndex: number;
  labelId: string;
  headCells: ColumnDefinition<T>[];
  row: T;
  borders?: boolean;
  onRowClick?: (rowIndex: number) => void;
  selectedRowIndex?: number;
  renderExpanded?: React.ReactNode;
};

export const DataTableRow = <T,>({
  rowIndex,
  labelId,
  row,
  headCells,
  borders = true,
  onRowClick = undefined,
  selectedRowIndex,
  renderExpanded,
}: Props<T>): React.ReactElement => {
  const classes = tableStyles();

  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
        key={rowIndex}
        data-testid={rowIndex}
        selected={selectedRowIndex === rowIndex}
        onClick={() => (onRowClick ? onRowClick(rowIndex) : null)}
      >
        {headCells.map((cell, index) => {
          const { id } = cell;
          const value = row[id] ? (row[id] as unknown as string) : '-';
          const render = cell.render;
          return (
            <TableCell
              key={id.toString()}
              component={'th' as unknown as ElementType<TableCellBaseProps>}
              id={`${labelId}-${index}`}
              data-testid={`${labelId}-${index}`}
              scope="row"
              width={cell.width}
              className={borders ? '' : classes.emptyTable}
              sx={{ maxWidth: '15vw', backgroundColor: cell.backgroundColor }}
            >
              {render ? (
                render(row)
              ) : value === '-' ? (
                <Typography>{value}</Typography>
              ) : (
                <Grid container direction="row" alignItems="flex-end">
                  <Grid item>
                    <Typography>{value}</Typography>
                  </Grid>
                </Grid>
              )}
            </TableCell>
          );
        })}
      </TableRow>
      {renderExpanded && rowIndex === selectedRowIndex && (
        <TableRow>
          <TableCell style={{ padding: 0 }} colSpan={headCells.length}>
            <Collapse in={selectedRowIndex === rowIndex && !!renderExpanded}>{renderExpanded}</Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};
